/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Comparative_Literature26Inputs */

const en__field_enum_study_comparative_literature26 = /** @type {(inputs: _Field_Enum_Study_Comparative_Literature26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparative Literature`)
};

const de__field_enum_study_comparative_literature26 = /** @type {(inputs: _Field_Enum_Study_Comparative_Literature26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeine und vergleichende Literaturwissenschaft`)
};

/**
* | output |
* | --- |
* | "Comparative Literature" |
*
* @param {_Field_Enum_Study_Comparative_Literature26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_comparative_literature26 = /** @type {((inputs?: _Field_Enum_Study_Comparative_Literature26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Comparative_Literature26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_comparative_literature26(inputs)
	return de__field_enum_study_comparative_literature26(inputs)
});
export { _field_enum_study_comparative_literature26 as "_field_enum_STUDY_COMPARATIVE_LITERATURE" }